import { useCallback, useEffect } from "react";
import { getMyUser } from "./remote/my-user";
import { logout } from "./remote/logout";
import { useUserSessionStorage, UserSessionData, UserSessionInfo } from "./SessionData"

export const useCurrentUser = (): [UserSessionData, (cb: ()=>void)=>void] => {
	const [userSessionData, setUserSessionData] = useUserSessionStorage(new UserSessionData());
	const logoutCallback = useCallback((cb: ()=>void) => {
		logout(() => {
			let newData = new UserSessionData();
			newData.currentUser = undefined;
			newData.loggedIn = false;
			setUserSessionData(newData);
			cb();
		})
	}, [userSessionData, setUserSessionData])
	if (userSessionData.loggedIn && !userSessionData.currentUser) {
		getMyUser((resp) => {
			if (resp?.status == 200)
			{
				let newData = new UserSessionData();
				Object.assign(newData, userSessionData);
				newData.currentUser = new UserSessionInfo();
				const responseData = JSON.parse(resp?.data);
				newData.currentUser.id = responseData["user_id"];
				newData.currentUser.name = responseData["name"];
				newData.currentUser.email = responseData["email"];
				newData.currentUser.phone = responseData["phone"];
				setUserSessionData(newData);
			}
			if (resp?.status == 403 || resp?.status == 401)
			{
				logoutCallback(() => {});
			}
		});
	} else if (userSessionData.currentUser && ! userSessionData.loggedIn) {
		let newData = new UserSessionData();
		newData.currentUser = undefined;
		newData.loggedIn = false;
		setUserSessionData(newData);
	}
	return [userSessionData, logoutCallback];
}
